/* eslint-disable array-callback-return */
import { Delete } from '@mui/icons-material';
import AddIcon from '@mui/icons-material/Add';
import { Box, Button, Divider, IconButton, Stack, Typography } from '@mui/material';
import Grid2 from '@mui/material/Unstable_Grid2/Grid2';
import { cloneDeep, get, set } from 'lodash';
import React, { FC, useEffect, useState } from 'react';
import CreateForm from 'src/components/ui-component/form-component/create-form/CreateForm';
import MUIAccordionComponent from 'src/components/ui-component/mui-accordion/MUIAccordionComponent';
import MUIAlert from 'src/components/ui-component/mui-alert/MUIAlert';
import { useApplication } from 'src/context/ApplicationContext';
import DeleteRecord from 'src/lib/api/DeleteRecord';
import GetRecords from 'src/lib/api/GetRecords';
import { APIS } from 'src/lib/constants/apis';
import { PERSONALAUSHABEN_STARTUPPROJEKTE } from 'src/lib/constants/componentsPath';
import {
	ALS_ERLEDIGT_MARKIEREN_LABEL,
	ERLAUTERUNG_IN_KOSTEN_TITLE,
	KOSTEN_ARTEN,
	KOSTEN_POSITION,
	PARTNER_DATEN_NICHT_ERFASST,
	PLATZHALTER_TEXT,
} from 'src/lib/constants/constant';
import { FormStrucItem } from 'src/lib/types/types';
import { ForceTrue } from 'src/lib/validation/ValidationTypes';
import { checkIfSpecificKostenPositionHasComment } from 'src/pages/private/online-antrag/application-helper-function/PruefAssistenzHelperFunktion';
import { withKostenkategorieEinsatzbereichFilter } from 'src/utils/einsatzbereichHelper';
import { DisplayEuro } from 'src/utils/formats';
import {
	addIndexesToPath,
	checkReadOnlyInUeberarbeitung,
	fieldNameTranslation,
	getFieldNamefromDataPath,
	getOptionsFromRes,
	removeDataKeys,
	removeNullDeep,
} from 'src/utils/helper';
import theme from '../../../../../../../assets/theme/theme';
import PruefAssistenz from '../../../../antrag-components/PruefAssistenz';
import ApplicationHeading from '../../../../application-heading/ApplicationHeading';
import {
	getBasicLeistungsGruppeFilter,
	getBasisDataKostenKategorie,
	getKostenErlauterung,
} from '../../../../application-helper-function/AppHelperfunctions';

// import schemas
import Schema from 'src/lib/paths/antrag_FULL_Paths.json';
import KostenPositionSchema from 'src/lib/paths/kostenposition_FULL_Paths.json';
const P = Schema.attributes;
const KP_P = KostenPositionSchema.attributes;

const PersonalKostenStartupProjekte: FC<{ kostentraeger: string; unternehmenId?: number; hasComment?: boolean }> = ({
	kostentraeger,
	unternehmenId,
	hasComment,
}) => {
	const { application, setApplicationProperty, readOnly, saveApplication } = useApplication();
	const [kostenKategorie, setKostenKategorie] = useState([]);
	const [leistungsgruppe, setLeistungsgruppe] = useState([]);

	const updatedReadOnly = checkReadOnlyInUeberarbeitung(application, readOnly, hasComment);

	const handleAddPersonalkosten = async () => {
		let appCopy = cloneDeep(application);
		// const projektStartJahr = get(appCopy, P.Allgemein_Projektstart_Jahr.path, 0);
		const projektDauerInJahren = get(appCopy, P.Allgemein_Projektdauerin_Jahren.path, 0);

		const data = getBasisDataKostenKategorie(
			appCopy,
			kostenKategorie, // All kostenkategorie for Sachkosten, to find default Kostenkategorie id
			kostentraeger,
			unternehmenId,
			KOSTEN_POSITION.Ausgabe,
			KOSTEN_ARTEN.Personalkosten,
		);
		set(
			data,
			getFieldNamefromDataPath(KP_P.Personalausgaben_Startup_Projekte.path),
			Array.from({ length: projektDauerInJahren }).map((_: any) => {
				return {
					// [getFieldNamefromDataPath(KP_P.Personalausgaben_Startup_Projekte.schema.attributes.Startup_Projekte_Betrachtetes_Jahr.path)]:
					// 	parseInt(projektStartJahr) + j,
					[getFieldNamefromDataPath(KP_P.Personalausgaben_Startup_Projekte.schema.attributes.Startup_P_Leistungsgruppe.path)]: null,
				};
			}),
		);
		set(
			appCopy,
			addIndexesToPath(
				P.Foerderantrag_Kostenpositions.path,
				[`${get(application, P.Foerderantrag_Kostenpositions.path, []).length}`],
				['Foerderantrag_Kostenpositions'],
			),
			{ attributes: data },
		);
		saveApplication(false, appCopy);
	};
	const handleDeletePersonalKosten = async (id: number) => {
		try {
			let appcopy = cloneDeep(application);
			const allKostenposition = get(appcopy, P.Foerderantrag_Kostenpositions.path, []);
			set(
				appcopy,
				P.Foerderantrag_Kostenpositions.path,
				allKostenposition.filter((item: any) => item.id !== id),
			);
			let res = await DeleteRecord(APIS.Kostenposition, id);
			if (res) {
				saveApplication(false, appcopy);
			}
		} catch (err: any) {
			console.error('ERROR: Deleting Personalkosten', err);
		}
	};
	const handleAddPersonalausgabenStartupProJahr = (kostenpositionIndex: number) => {
		let appCopy = cloneDeep(application);
		const personalAushabenBlock_Length = get(
			appCopy,
			addIndexesToPath(
				P.Foerderantrag_Kostenpositions.schema.attributes.Personalausgaben_Startup_Projekte.path,
				[`${kostenpositionIndex}`],
				['Foerderantrag_Kostenpositions'],
			),
			[],
		).length;
		const key = addIndexesToPath(
			P.Foerderantrag_Kostenpositions.schema.attributes.Personalausgaben_Startup_Projekte.schema.attributes
				.Startup_Projekte_Name_Der_Im_Vorhaben_Beschaeftigten_Person.path,
			[`${kostenpositionIndex}`, `${personalAushabenBlock_Length}`],
			['Foerderantrag_Kostenpositions', 'Personalausgaben_Startup_Projekte'],
		);
		const PersonNameVomBezeichnung = get(
			appCopy,
			addIndexesToPath(
				P.Foerderantrag_Kostenpositions.schema.attributes.Allgemein_Bezeichnung.path,
				[`${kostenpositionIndex}`],
				['Foerderantrag_Kostenpositions'],
			),
		);

		set(appCopy, key, PersonNameVomBezeichnung);
		saveApplication(false, appCopy);
	};
	const handleDeleteProJahr = (kostenpositionId: number, proJahrIndex: number) => {
		console.log(' kostenpostition id ', kostenpositionId, '  and proJahrIndex', proJahrIndex);
	};
	// Fetch Leitungsgruppe
	useEffect(() => {
		const fetch = async () => {
			try {
				const filter = getBasicLeistungsGruppeFilter(application);
				let res = await GetRecords(APIS.Leistungsgruppe, [], filter);
				setLeistungsgruppe(removeNullDeep(removeDataKeys(get(res, 'data'))));
			} catch (err: any) {
				console.error('ERROR: Fetching Leistungsgruppe ', err);
			}
		};
		fetch();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);
	// Fetch Kostenkategorie
	useEffect(() => {
		const fetch = async () => {
			try {
				const filter = withKostenkategorieEinsatzbereichFilter(
					{
						Allgemein_Kostenposition: 'Ausgabe',
						Allgemein_Kostenart_Finanzierung: 'Personalkosten',
						Allgemein_Antragsformular: { $contains: get(application, P.Allgemein_Antragsformular.path) },
						Allgemein_Aktiv: { $eq: true },
					},
					APIS.Antrag,
				);
				let res = await GetRecords(APIS.Kostenkategorie, [], filter);
				setKostenKategorie(removeNullDeep(removeDataKeys(get(res, 'data'))));
			} catch (err: any) {
				console.error('ERROR: Fetching Kostenkategorie ', err);
			}
		};
		fetch();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return (
		<>
			<ApplicationHeading title='Personalkosten' description={PLATZHALTER_TEXT} />
			{get(application, P.Foerderantrag_Kostenpositions.path, []).map((ele: any, i: number) => {
				if (
					get(ele, KP_P.Allgemein_Kostenposition.path) === KOSTEN_POSITION.Ausgabe &&
					get(ele, KP_P.Allgemein_Kostenart_Finanzierung.path) === KOSTEN_ARTEN.Personalkosten &&
					get(ele, `${KP_P.Unternehmen.path}.id`) === unternehmenId
				) {
					return (
						<MUIAccordionComponent
							key={i}
							summaryTitle={`Personalkosten - ${get(ele, KP_P.Allgemein_Bezeichnung.path, '')} - Gesamtsumme: ${DisplayEuro(get(ele, KP_P.Allgemein_Geplante_Gesamtsumme.path))}`}
							onDelete={() => handleDeletePersonalKosten(get(ele, 'id'))}
							showDeleteButton={!updatedReadOnly}
							hasComment={checkIfSpecificKostenPositionHasComment(readOnly, ele)}
						>
							<PruefAssistenz
								statusPath={addIndexesToPath(
									P.Foerderantrag_Kostenpositions.schema.attributes.Pruefung_Pruefstatus.path,
									[`${i}`],
									['Foerderantrag_Kostenpositions'],
								)}
								hinweisPath={addIndexesToPath(
									P.Foerderantrag_Kostenpositions.schema.attributes.Pruefung_Hinweis_Fuer_Antragsteller.path,
									[`${i}`],
									['Foerderantrag_Kostenpositions'],
								)}
								ueberarbeitetAmPath={addIndexesToPath(
									P.Foerderantrag_Kostenpositions.schema.attributes.Pruefung_Ueberarbeitet_Am.path,
									[`${i}`],
									['Foerderantrag_Kostenpositions'],
								)}
								erledigtPath={addIndexesToPath(
									P.Foerderantrag_Kostenpositions.schema.attributes.Pruefung_Erledigt.path,
									[`${i}`],
									['Foerderantrag_Kostenpositions'],
								)}
								formStruc={mapPersonalKosten(PruefAssistenzStruc(), i)}
							/>

							<MUIAlert
								title={ERLAUTERUNG_IN_KOSTEN_TITLE}
								message={getKostenErlauterung(kostenKategorie, get(ele, KP_P.Allgemein_Kostenkategorie.path))}
							/>
							<CreateForm
								formStruc={mapPersonalKosten(formStrucausPosition(kostenKategorie), i)}
								formValues={application}
								updateFormValuesFunc={setApplicationProperty}
								readOnly={updatedReadOnly}
								api={APIS.Kostenposition}
							/>
							<Divider sx={{ mt: '1rem', mb: '1rem' }} />
							<Stack direction={'row'} justifyContent={'flex-end'}>
								<Button endIcon={<AddIcon />} onClick={() => handleAddPersonalausgabenStartupProJahr(i)}>
									Projektjahr Hinzufügen
								</Button>
							</Stack>

							{get(ele, KP_P.Personalausgaben_Startup_Projekte.path, []).map((proJahr: any, j: number) => {
								return (
									<Box key={i + j} sx={{ mt: '0.5rem', border: `1px solid` + theme.palette.border.primary, padding: '1rem' }}>
										<Stack direction='row' justifyContent={'space-between'}>
											<Typography> Betrachtetes Jahr: {get(proJahr, PERSONALAUSHABEN_STARTUPPROJEKTE.Jahr)}</Typography>
											<IconButton onClick={() => handleDeleteProJahr(i, j)}>
												<Delete />
											</IconButton>
										</Stack>
										<Grid2 spacing={6} container>
											<Grid2 sm={6}>
												<CreateForm
													formStruc={mapAusgabenProJahrBlock(formStrucKalkulationBlockSpalte1(leistungsgruppe), i, j)}
													formValues={application}
													updateFormValuesFunc={setApplicationProperty}
													readOnly={updatedReadOnly}
													api={APIS.Kostenposition}
												/>
											</Grid2>
											<Grid2 sm={6}>
												<CreateForm
													formStruc={mapAusgabenProJahrBlock(formStrucKalkulationBlockSpalte2(), i, j)}
													formValues={application}
													updateFormValuesFunc={setApplicationProperty}
													readOnly={updatedReadOnly}
													api={APIS.Kostenposition}
												/>
											</Grid2>
										</Grid2>
										<CreateForm
											formStruc={mapPersonalKosten(formStrucKalkulationBlockBeschreibung(), i)}
											formValues={application}
											updateFormValuesFunc={setApplicationProperty}
											readOnly={updatedReadOnly}
											api={APIS.Kostenposition}
										/>
									</Box>
								);
							})}
						</MUIAccordionComponent>
					);
				}
			})}
			{unternehmenId ?
				<Button sx={{ mt: '2rem' }} endIcon={<AddIcon />} onClick={handleAddPersonalkosten} disabled={updatedReadOnly}>
					Personalkosten hinzufügen
				</Button>
			:	<MUIAlert message={PARTNER_DATEN_NICHT_ERFASST} />}
		</>
	);
};
export default PersonalKostenStartupProjekte;

const PruefAssistenzStruc = () => {
	let struc: FormStrucItem[] = [
		{
			fields: [
				{
					...P.Foerderantrag_Kostenpositions.schema.attributes.Pruefung_Erledigt,
					label: ALS_ERLEDIGT_MARKIEREN_LABEL,
					validation: [{ validateFunction: ForceTrue }],
				},
			],
		},
	];
	return struc;
};
const formStrucausPosition = (kostenKategorie?: any[]) => {
	const kategorieOptions = kostenKategorie || [];
	let struc: FormStrucItem[] = [
		{
			fields: [
				{
					...P.Foerderantrag_Kostenpositions.schema.attributes.Allgemein_Kostenkategorie,
					type: 'enumeration',
					options: getOptionsFromRes(kategorieOptions, 'Allgemein_Bezeichnung'),
				},
				{
					...P.Foerderantrag_Kostenpositions.schema.attributes.Allgemein_Bezeichnung,
					label: fieldNameTranslation(
						APIS.Kostenposition +
							'_' +
							getFieldNamefromDataPath(
								P.Foerderantrag_Kostenpositions.schema.attributes.Personalausgaben_Startup_Projekte.schema.attributes
									.Startup_Projekte_Name_Der_Im_Vorhaben_Beschaeftigten_Person.path,
							),
					),
				},
			],
		},
	];
	return struc;
};
const formStrucKalkulationBlockSpalte1 = (leistungsgruppe: any[]) => {
	const leistungsGruppen = leistungsgruppe || [];
	let struc: FormStrucItem[] = [
		{
			fields: [
				{
					...P.Foerderantrag_Kostenpositions.schema.attributes.Personalausgaben_Startup_Projekte.schema.attributes.Startup_P_Leistungsgruppe,
					type: 'enumeration',
					options: getOptionsFromRes(leistungsGruppen, 'Allgemein_Bezeichnung'),
				},
				P.Foerderantrag_Kostenpositions.schema.attributes.Personalausgaben_Startup_Projekte.schema.attributes
					.Startup_Projekte_Im_Beantragten_Vorhaben_Taetig,
			],
			userProps: { direction: 'column', columnToDivide: 1 },
		},
		{
			fields: [
				{
					...P.Foerderantrag_Kostenpositions.schema.attributes.Personalausgaben_Startup_Projekte.schema.attributes
						.Startup_Projekte_Monatssatz_Bzw_Stundensatz,
					disabled: true,
				},
				// P.Foerderantrag_Kostenpositions.schema.attributes.Personalausgaben_Startup_Projekte.schema.attributes
				// 	.Startup_Projekte_Anzahl_Monate_Bzw_Stunden_Geplant,
			],
		},
	];
	return struc;
};
const formStrucKalkulationBlockSpalte2 = () => {
	let struc: FormStrucItem[] = [
		// {
		// 	fields: [
		// 		P.Foerderantrag_Kostenpositions.schema.attributes.Personalausgaben_Startup_Projekte.schema.attributes.Startup_Projekte_Betrachtetes_Jahr,
		// 	],
		// 	userProps: { direction: 'column', columnToDivide: 1 },
		// },
		{
			fields: [
				P.Foerderantrag_Kostenpositions.schema.attributes.Personalausgaben_Startup_Projekte.schema.attributes
					.Startup_Projekte_Wochenstunden_Laut_Arbeitsvertrag,
				// P.Foerderantrag_Kostenpositions.schema.attributes.Personalausgaben_Startup_Projekte.schema.attributes
				// 	.Startup_Projekte_volle_Einsatzmonate_Im_Projekt,
				{
					...P.Foerderantrag_Kostenpositions.schema.attributes.Personalausgaben_Startup_Projekte.schema.attributes
						.Startup_Projekte_max_46_Einsatzstunden_Errechnet,
					disabled: true,
				},
			],
		},
		// {
		// 	fields: [
		// 		{
		// 			...P.Foerderantrag_Kostenpositions.schema.attributes.Personalausgaben_Startup_Projekte.schema.attributes.Startup_Projekte_Ausgaben,
		// 			format: 'currenry',
		// 			disabled: true,
		// 		},
		// 	],
		// 	userProps: { direction: 'column', columnToDivide: 1 },
		// },
	];
	return struc;
};
const formStrucKalkulationBlockBeschreibung = () => {
	let struc: FormStrucItem[] = [
		// {
		// 	fields: [
		// 		P.Foerderantrag_Kostenpositions.schema.attributes.Personalausgaben_Startup_Projekte.schema.attributes
		// 			.Startup_Projekte_Konkrete_Beschreibung_Im_Beantragten_Vorhaben,
		// 		P.Foerderantrag_Kostenpositions.schema.attributes.Personalausgaben_Startup_Projekte.schema.attributes
		// 			.Startup_Projekte_Darstellung_Der_Eignung_Vergleichbaren_Aufgaben,
		// 		P.Foerderantrag_Kostenpositions.schema.attributes.Personalausgaben_Startup_Projekte.schema.attributes
		// 			.Startup_Projekte_Begruendung_Der_Zuordnung_Gemaess_Merkblatt,
		// 	],
		// 	userProps: { direction: 'column', columnToDivide: 1 },
		// },
	];
	return struc;
};

const mapPersonalKosten = (formStruc: any[], index: number) => {
	let result = formStruc.map((row) => {
		return {
			...row,
			fields: (get(row, 'fields', []) as Array<any>).map((value) => {
				let pathWithoutIndex = get(value, 'path', '') as string;
				return {
					...value,
					path:
						pathWithoutIndex.slice(0, P.Foerderantrag_Kostenpositions.path.length) +
						`.${index}` +
						pathWithoutIndex.slice(P.Foerderantrag_Kostenpositions.path.length),
				};
			}),
		};
	});
	return result;
};
const mapAusgabenProJahrBlock = (formStruc: FormStrucItem[], kostenIndex: number, proJahrIndex: number) => {
	let result = formStruc.map((row: any) => {
		return {
			...row,
			fields: (get(row, 'fields', []) as Array<any>)
				.map((value) => {
					let pathWithoutIndex = get(value, 'path', '') as string;
					return {
						...value,
						path:
							pathWithoutIndex.slice(0, P.Foerderantrag_Kostenpositions.schema.attributes.Personalausgaben_Startup_Projekte.path.length) +
							`.${proJahrIndex}` +
							pathWithoutIndex.slice(P.Foerderantrag_Kostenpositions.schema.attributes.Personalausgaben_Startup_Projekte.path.length),
					};
				})
				.map((value) => {
					let pathWithoutIndex = get(value, 'path', '') as string;
					return {
						...value,
						path:
							pathWithoutIndex.slice(0, P.Foerderantrag_Kostenpositions.path.length) +
							`.${kostenIndex}` +
							pathWithoutIndex.slice(P.Foerderantrag_Kostenpositions.path.length),
					};
				}),
		};
	});
	return result;
};

export function getFormStrucPersonalKostenStartupProjekte(application: any, unternehmenId?: number): FormStrucItem[] {
	let formStruc: FormStrucItem[] = [];

	get(application, P.Foerderantrag_Kostenpositions.path, []).forEach((ele: any, _i: number) => {
		if (
			get(ele, KP_P.Allgemein_Kostenposition.path) === 'Ausgabe' &&
			get(ele, KP_P.Allgemein_Kostenart_Finanzierung.path) === 'Personalkosten' &&
			get(ele, `${KP_P.Unternehmen.path}.id`) === unternehmenId
		) {
			// const isHinweisFieldRequired = get(ele, KP_P.Pruefung_Hinweis_Fuer_Antragsteller.path) && !isTrue(get(ele, KP_P.Pruefung_Erledigt.path));
			// const formStrucCT2WithIndex = KalkulationBlockStruc(application, i);
			// const formStruc1WithIndex = mapPersonalKosten(formStrucSpalte1(), i);
			// const formStruc2WithIndex = mapPersonalKosten(formStrucSpalte2(), i);
			// const formStrucBeschreibungWithIndex = mapPersonalKosten(formStrucBeschreibung(), i);
			// if (isHinweisFieldRequired) {
			// 	formStruc = concat(
			// 		mapPersonalKosten(PruefAssistenzStruc(), i),
			// 		formStruc,
			// 		formStruc1WithIndex,
			// 		formStruc2WithIndex,
			// 		formStrucBeschreibungWithIndex,
			// 		// formStrucCT2WithIndex,
			// 	);
			// } else {
			// 	formStruc = concat(
			// 		formStruc,
			// 		formStruc1WithIndex,
			// 		formStruc2WithIndex,
			// 		formStrucBeschreibungWithIndex,
			// 		// formStrucCT2WithIndex,
			// 	);
			// }
		}
	});
	return formStruc;
}
